"use client";

import { useSession } from "@clerk/nextjs";
import { useCallback } from "react";

/**
 * Clerk 세션 JWT를 즉시 재발급하여 sessionClaims.publicMetadata를 최신화한다.
 *
 * 배경 (JCG-1452):
 * - `checkWriteAccess`가 `auth().sessionClaims.publicMetadata`로 권한을 빠르게 판정한다.
 * - JWT는 발급 시점의 스냅샷이라 publicMetadata 변경 직후 최대 ~50초간 옛 값이 박혀 있다.
 * - 본인이 트리거한 변경(결제 성공, PDF 구매, 무료체험 시작, YouTube 인증 등) 직후
 *   이 훅을 호출하면 다음 자동 rotate를 기다리지 않고 즉시 새 JWT를 받는다.
 *
 * 관리자가 다른 사용자의 metadata를 변경하는 경우(grant-free-pass 등)는
 * 대상 사용자의 클라이언트에서 호출할 방법이 없으므로 자연 rotate(~50초) 또는
 * 새로고침에 의존해야 한다.
 */
export function useRefreshSessionClaims() {
  const { session } = useSession();

  return useCallback(async () => {
    if (!session) return;
    try {
      await session.getToken({ skipCache: true });
    } catch (error) {
      console.error("세션 토큰 갱신 실패:", error);
    }
  }, [session]);
}
